import { useCallback, useState } from "react";
import { validateAuthFields } from "../validation/validator";
import { AuthFormValues, AuthMode } from "../validation/types";

export const useAuthValidation = () => {
  const [errors, setErrors] = useState<Record<string, string>>({});

  const validate = useCallback(
    (values: AuthFormValues, mode: AuthMode) => {
      const validationErrors = validateAuthFields(values, mode);
      const hasErrors = Object.values(validationErrors).some(
        (val) => val && val.trim() !== ""
      );

      setErrors(validationErrors);
      return { hasErrors, validationErrors };
    },
    []
  );

  return { errors, validate };
};

